/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Load_Preset_TitleInputs */

const en_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load a saved preset`)
};

const fr_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger un préréglage enregistré`)
};

const de_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine gespeicherte Voreinstellung laden`)
};

const it_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un preset salvato`)
};

const ru_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите сохраненный пресет`)
};

const es_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar un ajuste preestablecido guardado`)
};

const zh_cn2_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载已保存的预设`)
};

const ja_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存したプリセットを読み込む`)
};

const hi_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक सहेजा हुआ प्रीसेट लोड करें`)
};

const pt_pt2_subtitle_export_load_preset_title = /** @type {(inputs: Subtitle_Export_Load_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar uma predefinição salva`)
};

/**
* | output |
* | --- |
* | "Load a saved preset" |
*
* @param {Subtitle_Export_Load_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_load_preset_title = /** @type {((inputs?: Subtitle_Export_Load_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Load_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_load_preset_title(inputs)
	if (locale === "de") return de_subtitle_export_load_preset_title(inputs)
	if (locale === "it") return it_subtitle_export_load_preset_title(inputs)
	if (locale === "ru") return ru_subtitle_export_load_preset_title(inputs)
	if (locale === "es") return es_subtitle_export_load_preset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_load_preset_title(inputs)
	if (locale === "ja") return ja_subtitle_export_load_preset_title(inputs)
	if (locale === "hi") return hi_subtitle_export_load_preset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_load_preset_title(inputs)
	return en_subtitle_export_load_preset_title(inputs)
});